<div
  class="table-body overflow-auto"
  [ngClass]="{
    'table-body-empty':
      !loading &&
      (filterCount === 0 || (filterCount > 0 && paginatedData.length === 0))
  }"
>
  <div *ngIf="showDateRangeRequired" class="date-range-required-container">
    {{ "service_manager.history_service.date_range_required" | translate }}
  </div>
  <div class="table-body-head mb-3">
    <label class="table-title-filter">
      {{ "service_manager.history_service.filter_label" | translate }}
      ({{ filterCount }})
    </label>

    <tui-hosted-dropdown
      tuiDropdownLimitWidth="auto"
      [content]="download_options"
      [(open)]="exportOpen"
    >
      <button
        tuiHostedDropdownHost
        class="export-button"
        [disabled]="
          (!hasFiltered && paginatedData.length === 0) || exportLoading
        "
      >
        <img
          class="img-icon"
          src="../../../assets/icons/download-Icon.svg"
          alt=""
        />
        {{ "service_manager.history_service.export_text" | translate }} (.csv,
        xls..)
      </button>
    </tui-hosted-dropdown>
  </div>

  <div class="table-body-content">
    <form
      [formGroup]="filterForm"
      class="table-body-options mb-3"
      *ngIf="filterForm"
    >
      <!-- SEARCH -->
      <div class="search-bar filter-item">
        <img src="assets/icons/search-icon.svg" class="search-icon" alt="" />
        <input
          formControlName="search"
          type="text"
          class="search-bar-input"
          [placeholder]="
            'service_manager.history_service.search_text' | translate
          "
          [attr.aria-label]="
            'service_manager.history_service.search_text' | translate
          "
          [attr.aria-busy]="isSearching"
        />

        <div
          class="search-spinner"
          *ngIf="isSearching"
          aria-hidden="true"
          role="status"
        >
          <tui-loader size="s"></tui-loader>
        </div>
      </div>

      <!-- DATE RANGE -->
      <tui-input-date-range
        formControlName="dateRange"
        tuiTextfieldSize="s"
        [tuiTextfieldLabelOutside]="true"
        class="filter-item custom-select"
      >
        {{ "service_manager.history_service.date_input" | translate }}
        <input
          tuiTextfield
          [placeholder]="
            'service_manager.history_service.date_range_placeholder' | translate
          "
        />
      </tui-input-date-range>

      <!-- ZONE -->
      <ng-select
        formControlName="zoneGuids"
        [items]="zones"
        [multiple]="true"
        appendTo="body"
        bindLabel="zoneName"
        bindValue="zoneId"
        placeholder="{{
          'service_manager.history_service.zone_input' | translate
        }}"
        [clearable]="true"
        class="filter-item custom-select"
      ></ng-select>

      <!-- PRODUCTS -->
      <ng-select
        class="filter-item custom_select"
        formControlName="products"
        bindLabel="ProductLabel"
        bindValue="ProductKey"
        appendTo="body"
        [loading]="loadingProducts"
        [items]="products"
        [multiple]="true"
        [clearable]="true"
        placeholder="{{
          'service_manager.pending_service.products_input' | translate
        }}"
      ></ng-select>

      <!-- CLIENTS -->
      <ng-select
        formControlName="clientGuids"
        [items]="allClients"
        bindLabel="businessName"
        bindValue="userId"
        appendTo="body"
        [multiple]="true"
        placeholder="{{
          'service_manager.history_service.clients_input' | translate
        }}"
        class="filter-item custom-select"
      ></ng-select>

      <!-- STATUS -->
      <ng-select
        formControlName="orderStatuses"
        [items]="orderStatus"
        bindLabel="statusName"
        bindValue="orderStatus"
        appendTo="body"
        [multiple]="true"
        placeholder="{{
          'service_manager.history_service.status_input' | translate
        }}"
        class="filter-item custom-select"
      >
      </ng-select>

      <!-- VERTICALS -->
      <ng-select
        formControlName="verticalTypes"
        [items]="verticalOptions"
        bindLabel="label"
        bindValue="value"
        appendTo="body"
        [multiple]="true"
        [clearable]="true"
        placeholder="{{
          'service_manager.history_service.vertical_input' | translate
        }}"
        class="filter-item custom-select"
      >
      </ng-select>
    </form>

    <div *ngIf="loading">
      <tui-loader size="l"></tui-loader>
    </div>

    <!-- show table when backend reports results (filterCount) and not loading -->
    <table
      tuiTable
      size="l"
      style="width: 100%"
      [columns]="columns"
      *ngIf="!loading && filterCount > 0"
    >
      <thead>
        <tr tuiThGroup>
          <th
            class="th-style"
            *tuiHead="'licensePlate'"
            tuiTh
            (click)="setSortColumn('licensePlate')"
          >
            {{
              "service_manager.history_service.plate_input_table" | translate
            }}
          </th>

          <th
            [sticky]="true"
            *tuiHead="'orderHash'"
            tuiTh
            (click)="setSortColumn('orderHash')"
          >
            {{ "service_manager.history_service.hash_input_table" | translate }}
          </th>

          <th
            [sticky]="true"
            *tuiHead="'orderStatus'"
            tuiTh
            (click)="setSortColumn('orderStatus')"
          >
            {{
              "service_manager.history_service.status_input_table" | translate
            }}
          </th>

          <th
            [sticky]="true"
            *tuiHead="'date'"
            (click)="setSortColumn('date')"
            tuiTh
          >
            {{ "service_manager.history_service.date_input_table" | translate }}
          </th>

          <th
            [sticky]="true"
            *tuiHead="'time'"
            (click)="setSortColumn('time')"
            tuiTh
          >
            {{ "service_manager.history_service.hour_input_table" | translate }}
          </th>

          <th
            [sticky]="true"
            *tuiHead="'zoneName'"
            tuiTh
            (click)="setSortColumn('zoneName')"
          >
            {{ "service_manager.history_service.zone_input_table" | translate }}
          </th>

          <th
            [sticky]="true"
            *tuiHead="'verticalType'"
            tuiTh
            (click)="setSortColumn('verticalType')"
          >
            {{
              "service_manager.history_service.vertical_input_table" | translate
            }}
          </th>


          <th
            [sticky]="true"
            *tuiHead="'productName'"
            tuiTh
            (click)="setSortColumn('productName')"
          >
            {{
              "service_manager.history_service.product_input_table" | translate
            }}
          </th>

          <!-- Category column -->
          <ng-container *ngIf="shouldShowCategoryColumn()">
            <th
              [sticky]="true"
              *tuiHead="'category'"
              tuiTh
              (click)="setSortColumn('category')"
            >
              {{ "service_manager.pending_service.category" | translate }}
            </th>
          </ng-container>

          <th
            [sticky]="true"
            *tuiHead="'clientName'"
            tuiTh
            (click)="setSortColumn('clientName')"
          >
            {{
              "service_manager.history_service.client_input_table" | translate
            }}
          </th>

          <th
            [sticky]="true"
            *tuiHead="'originAddress'"
            tuiTh
            (click)="setSortColumn('originAddress')"
          >
            {{
              "service_manager.history_service.pickup_address_input_table"
                | translate
            }}
          </th>

          <th
            [sticky]="true"
            *tuiHead="'destinationAddress'"
            tuiTh
            (click)="setSortColumn('destinationAddress')"
          >
            {{
              "service_manager.history_service.delivery_input_table" | translate
            }}
          </th>

          <th
            [sticky]="true"
            *tuiHead="'driversNameDisplay'"
            tuiTh
            (click)="setSortColumn('driversNameDisplay')"
          >
            {{ "service_manager.history_service.driver_name" | translate }}
          </th>

          <th
            [sticky]="true"
            *tuiHead="'additionalInformation'"
            tuiTh
            (click)="setSortColumn('additionalInformation')"
          >
            {{
              "service_manager.history_service.comments_input_table" | translate
            }}
          </th>

          <th
            [sticky]="true"
            *tuiHead="'totalPrice'"
            tuiTh
            (click)="setSortColumn('totalPrice')"
          >
            {{
              "service_manager.history_service.totalPrice_input_table"
                | translate
            }}
          </th>

          <th [sticky]="true" *tuiHead="'actions'" tuiTh [sorter]="null">
            {{
              "service_manager.history_service.actions_input_table" | translate
            }}
          </th>
        </tr>
      </thead>

      <tbody tuiTbody *ngIf="paginatedData.length > 0">
        <tr
          tuiTr
          *ngFor="let item of paginatedData; trackBy: trackByServiceGuid"
        >
          <td *tuiCell="'licensePlate'" tuiTd>
            <div class="vertical-align">
              <span tuiTitle>{{ item.licensePlate }}</span>
            </div>
          </td>

          <td *tuiCell="'orderHash'" tuiTd>
            <div [tuiCell]="size">
              <span tuiTitle>{{ item.orderHash }}</span>
            </div>
          </td>

          <td *tuiCell="'orderStatus'" tuiTd>
            <div [tuiCell]="size">
              <ng-container
                *ngIf="item.orderStatus | orderStatusBadge as badge"
              >
                <tui-badge
                  [status]="badge.tuiStatus"
                  [value]="badge.key | translate"
                  class="tui-space_right-2 tui-space_bottom-2"
                  [ngClass]="badge.cssClass"
                ></tui-badge>
              </ng-container>
            </div>
          </td>

          <td *tuiCell="'date'" tuiTd>
            <div [tuiCell]="size">
              <span tuiTitle>{{ item.displayDate }}</span>
            </div>
          </td>

          <td *tuiCell="'time'" tuiTd>
            <div [tuiCell]="size">
              <span tuiTitle>{{ item.displayTime }}</span>
            </div>
          </td>

          <td *tuiCell="'zoneName'" tuiTd>
            <div [tuiCell]="size">
              <span tuiTitle>{{ item.zoneName }}</span>
            </div>
          </td>

          <td *tuiCell="'verticalType'" tuiTd>
            <div [tuiCell]="size">
              <span tuiTitle>{{
                item.verticalType | verticalName | translate
              }}</span>
            </div>
          </td>


          <td *tuiCell="'productName'" tuiTd>
            <div [tuiCell]="size">
              <span tuiTitle>{{ serviceTypeLabel(item.productName) }}</span>
            </div>
          </td>

          <!-- Category cell -->
          <ng-container *ngIf="shouldShowCategoryColumn()">
            <td *tuiCell="'category'" tuiTd>
              <ng-container *ngIf="item.category as cat; else noCat">
                {{ cat }}
              </ng-container>
              <ng-template #noCat>—</ng-template>
            </td>
          </ng-container>

          <td *tuiCell="'clientName'" tuiTd>
            <span tuiTitle>
              {{ item.clientName }}
            </span>
          </td>

          <td *tuiCell="'phoneNumber'" tuiTd>
            <span tuiTitle>
              {{ item.phoneNumber || "-" }}
            </span>
          </td>

          <td *tuiCell="'originAddress'" tuiTd>
            <div tuiCell="l" class="address-cell">
              <span tuiTitle>{{ item.originAddress }}</span>
            </div>
          </td>

          <td *tuiCell="'destinationAddress'" tuiTd>
            <div tuiCell="l" class="address-cell">
              <span tuiTitle>{{ item.destinationAddress }}</span>
            </div>
          </td>

          <td *tuiCell="'driversNameDisplay'" tuiTd>
            <ng-container *ngIf="item.driversName?.length; else noDriversHistory">
              <div class="driver-lines" tuiTitle>
                <span class="driver-line" *ngFor="let driverName of item.driversName">
                 {{ driverName }}
                </span>
              </div>
            </ng-container>
            <ng-template #noDriversHistory>
              <span class="driver-unassigned-chip" tuiTitle>
                {{ "service_manager.history_service.unassigned_driver" | translate }}
              </span>
            </ng-template>
          </td>

          <td *tuiCell="'additionalInformation'" tuiTd>
            <span tuiTitle>
              <label>{{ item.additionalInformation }}</label>
              <label *ngIf="!item?.additionalInformation"> - </label>
            </span>
          </td>

          <td *tuiCell="'totalPrice'" tuiTd>
            <ng-container *ngIf="item.totalPrice != null; else noPrice">
              <span tuiTitle tuiCell="l">
                {{ item.totalPrice | number : "1.2-2" }}
                {{ item.currencySymbol }}
              </span>
            </ng-container>
            <ng-template #noPrice>
              <span tuiTitle>–</span>
            </ng-template>
          </td>

          <td *tuiCell="'actions'" tuiTd>
            <span class="seeAllIcon" tuiStatus>
              <button
                class="seeAllIcon"
                appearance="link"
                icon="tuiIconEye"
                size="xs"
                tuiAppearance="link"
                tuiIconButton
                (click)="viewDetail(item)"
              >
                <span>
                  {{
                    "service_manager.history_service.action_view_results"
                      | translate
                  }}
                </span>
              </button>
            </span>
          </td>
        </tr>
      </tbody>
    </table>

    <div
      *ngIf="
        !loading &&
        (filterCount === 0 || (filterCount > 0 && paginatedData.length === 0))
      "
      class="empty-state-content"
    >
      <div
        *ngIf="filterCount === 0"
        class="no-results-message"
      >
        {{ "service_manager.history_service.no_services_at_all" | translate }}
      </div>

      <div
        *ngIf="filterCount > 0 && paginatedData.length === 0"
        class="no-results-message"
      >
        {{ "service_manager.history_service.no_services_found" | translate }}
      </div>
    </div>
  </div>

  <div class="table-pagination" *ngIf="filterCount > 0 && !loading">
    <tui-pagination
      [index]="index"
      [length]="length"
      (indexChange)="goToPage($event)"
    ></tui-pagination>
  </div>
</div>

<ng-template #download_options let-activeZone>
  <div class="download-menu">
    <label class="mb-2 export-title">{{
      "service_manager.history_service.complement_export_text" | translate
    }}</label>

    <div class="d-flex mb-2 export-body-label">
      <tui-checkbox
        [(ngModel)]="isXlsxSelected"
        (ngModelChange)="updateExportCount()"
        class="tui-space_bottom-3"
        [disabled]="exportLoading"
      ></tui-checkbox>
      <label>Excel(.xlsx)</label>
    </div>

    <div class="d-flex mb-2 export-body-label">
      <tui-checkbox
        [(ngModel)]="isCsvSelected"
        (ngModelChange)="updateExportCount()"
        class="tui-space_bottom-3"
        [disabled]="exportLoading"
      ></tui-checkbox>
      <label>Excel(.csv)</label>
    </div>

    <button
      (click)="exportTo()"
      class="export-button-menu mb-2 mt-1"
      [disabled]="exportCount === 0 || exportLoading"
      [attr.aria-busy]="exportLoading"
      type="button"
    >
      <div *ngIf="!exportLoading" class="d-flex align-items-center">
        <img
          class="img-icon"
          src="../../../assets/icons/download-Icon.svg"
          alt=""
        />
        <span *ngIf="!exportLoading">
          {{ "service_manager.history_service.export_text" | translate }}
          ({{ exportCount }})
        </span>
      </div>

      <div *ngIf="exportLoading">
        <span class="exporting-inline">
          <tui-loader size="s"></tui-loader>
        </span>
      </div>
    </button>
  </div>
</ng-template>
